// extracted by mini-css-extract-plugin
export default {"textButton":"HLTextButton_textButton__449Pt"};